
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/openai-api-playground-ui-with-chat-history",
      function () {
        return require("private-next-pages/openai-api-playground-ui-with-chat-history.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/openai-api-playground-ui-with-chat-history"])
      });
    }
  